import { render, staticRenderFns } from "./Administracia.vue?vue&type=template&id=614f6c32&"
import script from "./Administracia.vue?vue&type=script&lang=js&"
export * from "./Administracia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('614f6c32')) {
      api.createRecord('614f6c32', component.options)
    } else {
      api.reload('614f6c32', component.options)
    }
    module.hot.accept("./Administracia.vue?vue&type=template&id=614f6c32&", function () {
      api.rerender('614f6c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Administracia.vue"
export default component.exports